import { TripExpense } from '../types/TripExpense';

/**
 * Groups expense items by category. Returns an object with category names mapped to summed totals.
 * @param expenses
 * @returns
 */
function getGroupedExpenses(expenses: TripExpense[]) {
  const groupedExpenses = expenses.reduce<Record<string, TripExpense>>(
    (acc, expense) => {
      if (!acc[expense.title]) {
        acc[expense.title] = {
          title: expense.title,
          cost: 0,
          isQuoted: expense.isQuoted || false,
          receipt: expense.receipt || '',
        };
      }
      acc[expense.title].cost += expense.cost;
      return acc;
    },
    {}
  );
  return groupedExpenses;
}

export default getGroupedExpenses;
